(function () {
  // Sticky header shadow
  var header = document.getElementById('SiteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }
  // Mobile nav
  var toggle = document.getElementById('MenuToggle');
  var nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  // Product gallery thumbs
  var main = document.getElementById('MainImage');
  if (main) {
    document.querySelectorAll('.thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full;
        main.removeAttribute('srcset');
        document.querySelectorAll('.thumbs img').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }
  // Collection sorting
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });
  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }
})();
(function () {
  var about = document.getElementById('CAbout');
  var toggle = document.getElementById('CAboutToggle');
  if (about && toggle) {
    // hide the toggle if text is short enough not to clamp
    if (about.scrollHeight <= about.clientHeight + 8) { toggle.style.display = 'none'; about.classList.add('open'); }
    toggle.addEventListener('click', function () {
      var open = about.classList.toggle('open');
      toggle.textContent = open ? 'Read less' : 'Read more';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
